<template>
  <article class="card has-border-dark course-module-card">
    <div class="card-content">
      <p class="module">{{ `Module ${order + 1}` }}</p>
      <h3 class="name">{{ name }}</h3>
      <p class="description">{{ description }}</p>
      <template v-if="userIsEnrolled && progress">
        <hr>
        <div class="actions">
          <Button size="medium" type="secondary" disabled v-if="isLocked">Start</Button>
          <Button size="medium" type="secondary" :to="toLesson" v-else>{{ buttonText }}</Button>
          <progress-bar :max="module.lessons.length || 100" :progress="completedLessons || 0" v-if="module"></progress-bar>
        </div>
      </template>
    </div>
  </article>
</template>

<script>
import ProgressBar from '@/components/ProgressBar'
import Button from '@/components/Button'

import { mapState } from 'vuex'

export default {
  name: 'course-module-card',

  components: {
    ProgressBar,
    Button
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    order: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: false
    },
    userIsEnrolled: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    ...mapState('course', {
      progress: state => state.progress
    }),

    module () {
      return this.$store.getters['course/getModuleProgress'](this.id)
    },

    buttonText () {
      if (this.isFinished) {
        return 'View'
      } else if (this.isUnstarted || this.isLocked) {
        return 'Start'
      } else {
        return 'Continue'
      }
    },

    isFinished () {
      if (!this.module) return false
      return this.module.status === 'completed'
    },

    isLocked () {
      if (!this.module) return true
      return this.module.status === 'locked'
    },

    isUnstarted () {
      return this.progress.currentLesson === 0
    },

    completedLessons () {
      if (this.isFinished) return this.module.lessons.length
      else if (this.isLocked) return 0
      else return this.progress.currentLesson
    },

    toLesson () {
      return {
        name: 'lesson',
        params: { courseId: this.courseId, moduleId: this.id, lessonId: this.currentLessonId }
      }
    },

    currentLessonId () {
      if (this.isFinished) {
        return this.module.lessons[0].id
      } else if (this.module && this.module.nextLesson) {
        return this.module.nextLesson.id
      } else {
        return null
      }
    }
  },

  data () {
    return {
      courseId: this.$route.params.courseId
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.course-module-card {
  @include text-size-m();

  .module,
  .name {
    margin-bottom: .5rem;
  }

  hr {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }

  .module {
    @include text-size-xs();
    font-weight: $font-weight-semibold;
    text-transform: uppercase;
  }

  .name {
    color: $color-text-dark;
    @include text-size-xl();
    font-weight: $font-weight-semibold;
  }

  .actions {
    display: flex;
    align-items: center;
  }

  .progress-bar {
    flex: 0 0 10rem;
    margin-left: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CourseModuleCard.vue